import { Decimal } from "decimal.js";

Decimal.set({ precision: 10 });

export const DPI = Decimal.acos("-1");

Decimal.set({ precision: 6 });

export const D_1 = Decimal("-1");
export const D0 = Decimal("0");
export const D0_1 = Decimal("0.1");
export const D0_5 = Decimal("0.5");
export const D1 = Decimal("1");
export const D2 = Decimal("2");
export const D3 = Decimal("3");
export const D4 = Decimal("4");
export const D5 = Decimal("5");
export const D6 = Decimal("6");
export const D7 = Decimal("7");
export const D8 = Decimal("8");
export const D9 = Decimal("9");
export const D10 = Decimal("10");
export const D11 = Decimal("11");
export const D12 = Decimal("12");
export const D16 = Decimal("16");
export const D18 = Decimal("18");
export const D19 = Decimal("19");
export const D20 = Decimal("20");
